import { Controller, useFormContext } from 'react-hook-form';
import { TmdxTextarea } from '@ds';
import { FormSection } from '@features/components/CaseFormBlocks/components';
import { DonorFormRow } from './DonorFormRow';
import { MatchIdRow } from './MatchIdRow';
import { ReasonForUnallocatedRow } from './ReasonForUnallocatedRow';
import { DonorProfileFormValues } from '../types';
import { createOrganField, OrganAdditionalInfoSectionProps } from '../organField';

export const HeartAdditionalInfoSection = ({
  namePrefix,
  title = 'Additional Information',
  showReasonForUnallocated = true,
  showMatchId = false,
}: OrganAdditionalInfoSectionProps) => {
  const { control } = useFormContext<DonorProfileFormValues>();
  const organField = createOrganField(namePrefix);

  return (
    <FormSection title={title}>
      {showMatchId && <MatchIdRow namePrefix={namePrefix} />}
      {showReasonForUnallocated && <ReasonForUnallocatedRow />}

      <DonorFormRow title="List of OCS Centers on Match Run" multiRow>
        <Controller
          name={organField('ocsMatchRunCenters')}
          control={control}
          render={({ field: centersField, fieldState: { invalid, error } }) => (
            <TmdxTextarea
              placeholder="Enter centers"
              aria-label="List of OCS Centers on Match Run"
              maxLength={128}
              isInvalid={invalid}
              errorMessage={error?.message}
              {...centersField}
              value={centersField.value ?? ''}
            />
          )}
        />
      </DonorFormRow>
    </FormSection>
  );
};
